import React, { Component } from 'react';
// import { Provider } from 'react-redux';
import { Provider, observer } from 'mobx-react';
// import storeCreator from './store_creator';
import MyAnimeShelf from './components/MyAnimeShelf.jsx'
import { history } from "./history_mobx";
import myStore from "./stores/store";
import { Router } from "react-router";


class App extends Component {
  render() {
    return (
      <Provider {...myStore.getStores()}>
        <Router history={history}>
          <MyAnimeShelf />
        </Router>
      </Provider>
    );
  }
}

export default observer(App);
